import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, ViewChild, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Location} from '@angular/common';
// Notifications
// import { HotToastService } from '@ngneat/hot-toast';
import { DatePipe } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Observable, map, of } from 'rxjs'; // this created errors ats use below
// import {Observable} from 'rxjs/Rx';






import { MysqlService } from './../../../services/mysql.service';
import { Brand } from '../../../shared/models/brand.model';
import {SubjectTemplateDocs} from '../../../shared/models/subjectTemplateDocsModel.model';

import { FormsModule, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { ToolbarService, LinkService, ImageService, HtmlEditorService, EditorManager, QuickToolbarSettingsModel, InsertHtml } from '@syncfusion/ej2-angular-richtexteditor';
import {
  RichTextEditorComponent,
  NodeSelection
} from '@syncfusion/ej2-angular-richtexteditor';

import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { HotToastService } from '@ngneat/hot-toast';
import { UploadDocxTemplateModalComponent } from '../../communication-manager/upload-docx-template-modal/upload-docx-template-modal.component';
import { UploadDocxThemeTemplateComponent } from '../../communication-manager/upload-docx-theme-template/upload-docx-theme-template.component';
import { UploadDotTemplateModalComponent } from '../../communication-manager/upload-dot-template-modal/upload-dot-template-modal.component';
import { UploadEmailTemplateModalComponent } from '../../communication-manager/upload-email-template-modal/upload-email-template-modal.component';
import { SystemAutomation } from 'src/app/shared/models/systemAutomation.model';
import { DropDownList, DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { WooPromotionVariableModalComponent } from '../../system-variables/woo-promotion-variable-modal/woo-promotion-variable-modal.component';
import { DataUtil, Predicate, Query } from '@syncfusion/ej2-data';
import { LegalDateTimeService } from './../../../services/legal-datetime.service';
@Component({
  selector: 'app-system-automation-update',
  templateUrl: './system-automation-update.component.html',
  styleUrls: ['./system-automation-update.component.scss'],
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService]
})
export class SystemAutomationUpdateComponent implements OnInit {


  nav: any;
  doc_id: number;
  // model: SubjectTemplateDocs;
  model: SystemAutomation;

  subject_template_doc: any;
  public cValue: string = "#1de4d7";
  @Input('brandForm') brandForm: any;
  array_of_triggers: any[];
  system_log_type_automation_triggers: Object;
  job_status_run: any;
  system_subject_template_docs_automations_2: any;
  system_subject_template_docs_automations_commuications_2: any;
  @Input('value')
  set value(value: any) {
      this.cValue = value;
  }
  changes_made: any = 1;

  public baseUploadURL: any;
  @ViewChild('brandForm') form: any; // the name of the form to access.
  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  stripped: any;
  filenameselected: any;
  brand_types: any;
  baseUploadURLEmailTemplates: string;
  subject_com_types: any;
  sent_subject_com_type_id: any;

  job_types: any;
  job_subject_types: any;
  job_plaintiff_types: any;
  job_type_locations: any;
  count2: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  doc_check: any;

  get_name: any;
  baseUploadURLOriginalWordTemplates: string;

  public myValue = 0;
  baseUploadURLDocxThemeTemplates: string;
  system_automation: any;
  system_automation_id: number;
  all_router_details: string;

  isShow_condition_array = false;
  isShow_condition_array_example = false;
  isShow_condition_array_keys_example = false;
  isShow_condition_array_fields = false;
  isShow_database = false;
  isShow_database_model_angular = false;
  isShow_database_mysql = false;
  isShow_advanced_features = false;
  isShow_developer_features = false;
  isShow_conditions = false;
  isShow_notes = false;
  isShow_emails = false;
  isShow_files = false;
  isShow_files2 = false;
  isShow_company_privacy = false;
  isShow_change_dates = false;
  isShow_change_job_status = false;
  legalDatePickerValues: { [field: string]: Date | null } = {};




  public insertImageSettings = {
    display: 'inline'
};

public mode: string = 'Markdown'; // Sets and removes for safe HTML/Sanitise etc  HTML | Markdown



// @ViewChild('defaultRTE', {static: false}) defaultRTE;
@ViewChild('RTEmail_template_owner', {static: false}) RTEemail_template_owner;

@ViewChild('defaultRTE', {static: false}) defaultRTE;
@ViewChild('defaultRTE_b', {static: false}) defaultRTE_b;

@ViewChild('noteTemplateEditor', {static: false}) noteTemplateEditor;
@ViewChild('emailTemplateEditor', {static: false}) emailTemplateEditor;
@ViewChild('noteTemplateEditorPrivate', {static: false}) noteTemplateEditorPrivate;
@ViewChild('emailTemplateEditorPrivate', {static: false}) emailTemplateEditorPrivate;
@ViewChild('emailSignatureTemplate', {static: false}) emailSignatureTemplate;




@ViewChild('ejDialog', {static: false}) defaultDialog;
@ViewChild('ddlelement2', {static: false}) 
public countryObj: DropDownListComponent; 
public dropDownListObject: DropDownList
public editorManager: EditorManager; 
public proxy:any
public isParentDropdownChanged: boolean = false;
public rteObj: RichTextEditorComponent;

public dropdownVariables: DropDownList
@ViewChild("sample")
public listObj: DropDownListComponent;
  note_types: any;
  brand: Object;
  promotion_id: any;
  brand_id: string;
  dropdownVariablesOrder: DropDownList;
  dropdownVariablesOrderSender: DropDownList;
  dropdownVariablesOrderPickList: DropDownList;
  variable_code_blocks_metrix_search_full: any;
  variable_code_blocks_metrix_search_full_results: any;
  new_data: any;
  search_model: {  };

  dynamic_dropdownVariables: DropDownList
  dynamic_data: { [key: string]: Object; }[];
  dropdownVariablesDynamic: DropDownList;
  dropdownVariables_AutomationGeneral: DropDownList;
  automationGeneral_data: { [key: string]: Object; }[];

  allFileAutomations = [];
  allCommunicationsAutomations = [];
  allConditionsAutomations = [];
  allFileAutomations_2 = [];
  allCommunicationsAutomations_2 = [];
  allConditionsAutomations_2 = [];
  system_log_type_automations: Object;
  system_subject_template_docs_automations: any;
  system_subject_template_docs_automations_commuications: any;
  system_log_type_data_sectors: any;
  system_log_type_data_sector_conditions: any;
  users: any;

  public opened() {
    // this.defaultRTE.refreshUI();
    // this.RTEemail_template_owner.refreshUI();
  }
  
  // base product sample model based on Order ID 19348
  
  
  // my custom drop downs
  public height: any = '350px';
  
  

  
  public tools: object = {
    type: 'MultiRow',
        items: [ 
          'CreateTable',  '|' ,
          // {
          //   tooltipText: "PlaceHolder DropDown",        
          //   template:
          //     '<table><tr><td><input type="text" tabindex="1" id="ddlelement" /></td></tr></table>'
          // },
           '|',
        //   {
        //     tooltipText: 'Insert My Brand Variables',
        //     template: '<input type="text" id="dropdownVariables"/>'
        // },
        {
          tooltipText: 'Dynamic Variables',
          template: '<input type="text" id="dropdownVariablesDynamic" />'
      },
      {
        tooltipText: 'Automation General',
        template: '<input type="text" id="dropdownVariablesAutomationGeneral" />'
    },
        {
          tooltipText: 'Order Variables',
          template: '<input type="text" id="dropdownVariablesOrder" />'
      },
      {
        tooltipText: 'Order Sender',
        template: '<input type="text" id="dropdownVariablesOrderSender" />'
    },
      {
        tooltipText: 'Pick List Items',
        template: '<input type="text" id="dropdownVariablesOrderPickList" />'
    },
       '|',
      // {
      //   tooltipText: 'Insert/Upload Image',
      //   undo: true,
      //   click: this.onClickImageButton.bind(this),
      //   template: '<button type="button" class="btn btn-default"><i class="fa fa-photo"></i></button>'
      // },
      {
        tooltipText: 'Insert Promotion',
        undo: true,
        click: this.onClickPromotionButton.bind(this),
        template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
      },
       '|',      
    'Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat',
    'SourceCode', 'FullScreen', '|', 'Undo', 'Redo', '|', 
  
    ]
    };
  
  
    // Repalce
   public quickToolbarSettings: QuickToolbarSettingsModel = {
      image: [
           'Align', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-',
          'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension'
      ],
      table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };
  
  public size = {
      width: '40px',
      items: [{ text: '8', value: '8pt' },
      { text: '10', value: '10pt' },
      { text: '12', value: '12pt' },
      { text: '14', value: '14pt' },
      { text: '42', value: '42pt' }]
  };
  public family = {
      width: '60px',
      items: [
      { text: 'Segoe UI', value: 'Segoe UI' },
      { text: 'Arial', value: 'Arial,Helvetica,sans-serif' },
      { text: 'Courier New', value: 'Courier New,Courier,monospace' },
      { text: 'Georgia', value: 'Georgia,serif' },
      { text: 'Impact', value: 'Impact,Charcoal,sans-serif' },
      { text: 'Calibri Light', value: 'CalibriLight' }]
  };


  public dataVariables: { [key: string]: Object }[] = [
    // { Id: '2', Name: 'FirstName' },
    // { Id: '2', Name: 'LastName' },
    // { Id: '3', Name: 'MiddleName' }
  
  // :: Owner mergeOwnerData
  { Id: '', Category: 'Owner', Name: 'Owner Business Name', insertValue: '${owner_business_name}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Phone', insertValue: '${owner_phone}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Address 1', insertValue: '${owner_address_1}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Address 2', insertValue: '${owner_address_2}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Suburb', insertValue: '${owner_suburb}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner State', insertValue: '${owner_state}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Postcode', insertValue: '${owner_postcode}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Country', insertValue: '${owner_country}', description: '' },
  { Id: '', Category: 'Owner', Name: 'Owner Type', insertValue: '${owner_brand_type_id}', description: '' },
  ];
  
  
  public dataVariablesOrder: { [key: string]: Object }[] = [
  // :: WordPress Order mergeOwnerData
  { Id: '', Category: 'Order', Name: 'OrderID', insertValue: '${order_id}', description: '' },
  { Id: '', Category: 'Order', Name: 'Order Company Output', insertValue: '${order_shipping_company_output}', description: '' },
  { Id: '', Category: 'Order', Name: 'Order Company', insertValue: '${order_shipping_company}', description: '' },
  { Id: '', Category: 'Order', Name: 'First Name Abrv.', insertValue: '${order_shipping_first_name_abr}', description: '' },
  { Id: '', Category: 'Order', Name: 'First Name', insertValue: '${order_shipping_first_name}', description: '' },
  { Id: '', Category: 'Order', Name: 'Surname', insertValue: '${order_shipping_first_name}', description: '' },
  
  { Id: '', Category: 'Order', Name: 'Address Line 1', insertValue: '${order_shipping_address_1}', description: '' },
  { Id: '', Category: 'Order', Name: 'Address Line 2', insertValue: '${order_shipping_address_2}', description: '' },
  { Id: '', Category: 'Order', Name: 'City', insertValue: '${order_shipping_city}', description: '' },
  { Id: '', Category: 'Order', Name: 'State', insertValue: '${order_shipping_state}', description: '' },
  { Id: '', Category: 'Order', Name: 'Postcode', insertValue: '${order_shipping_postcode}', description: '' },
  { Id: '', Category: 'Order', Name: 'Country Abrv.', insertValue: '${order_shipping_country}', description: '' },
  
  
  
  { Id: '', Category: 'Order', Name: 'Shipping Method', insertValue: '${shipping_data_method_title}', description: '' },
  { Id: '', Category: 'Order', Name: 'Shipping Total', insertValue: '${shipping_data_total}', description: '' },
  
  { Id: '', Category: 'Order', Name: 'Customm Postage Output', insertValue: '${owner_brand_type_id}', description: '' },
  { Id: '', Category: 'Order', Name: 'Order Items Table', insertValue: '${items}', description: '' },
  { Id: '', Category: 'Order', Name: 'Order Items Table Alternative', insertValue: '${items2}', description: '' },
  
  { Id: '', Category: 'Order', Name: 'Item Full - CodeOutPut', insertValue: '${item_full}', description: '' },
  { Id: '', Category: 'Order', Name: 'CurrentID', insertValue: '${id}', description: '' },
  
  ];
  
  
  
  public dataVariablesOrderSender: { [key: string]: Object }[] = [
    // :: WordPress Order mergeOwnerData
    { Id: '', Category: 'Order', Name: 'Order From Company Output', insertValue: '${order_from_shipping_company_output}', description: '' },
    { Id: '', Category: 'Order', Name: 'Order From Company', insertValue: '${order_from_shipping_company}', description: '' },
    // { Id: '', Category: 'Order', Name: 'First Name Abrv.', insertValue: '${order_shipping_first_name_abr}', description: '' },
    // { Id: '', Category: 'Order', Name: 'First Name', insertValue: '${order_shipping_first_name}', description: '' },
    // { Id: '', Category: 'Order', Name: 'Surname', insertValue: '${order_shipping_first_name}', description: '' },
    
    { Id: '', Category: 'Order', Name: 'From Address Line 1', insertValue: '${order_from_shipping_address_1}', description: '' },
    { Id: '', Category: 'Order', Name: 'From Address Line 2', insertValue: '${order_from_shipping_address_2}', description: '' },
    { Id: '', Category: 'Order', Name: 'From City', insertValue: '${order_from_shipping_city}', description: '' },
    { Id: '', Category: 'Order', Name: 'From State', insertValue: '${order_from_shipping_state}', description: '' },
    { Id: '', Category: 'Order', Name: 'From Postcode', insertValue: '${order_from_shipping_postcode}', description: '' },
    { Id: '', Category: 'Order', Name: 'From Country Abrv.', insertValue: '${order_from_shipping_country}', description: '' },
    
    
    ];
  
  
    public dataVariablesOrderPickList: { [key: string]: Object }[] = [
      // :: WordPress Order mergeOwnerData
      { Id: '', Category: 'Order', Name: 'Pick List Title', insertValue: '${pick_list_title}', description: '' },
      { Id: '', Category: 'Order', Name: 'Today', insertValue: '${now_today}', description: '' },
      
      { Id: '', Category: 'Order', Name: 'Created - TimeStamp Words', insertValue: '${now_full_words}', description: '' },
      { Id: '', Category: 'Order', Name: 'Pick List Table Header', insertValue: '${pick_list_items_header}', description: '' },
      { Id: '', Category: 'Order', Name: 'Pick List Items (All) Table', insertValue: '${pick_list_items}', description: '' },
      { Id: '', Category: 'Order', Name: 'Pick List Items (Ebay) Table', insertValue: '${pick_list_ebay_items}', description: '' },
      { Id: '', Category: 'Order', Name: 'Pick List Items (WooCheckout) Table', insertValue: '${pick_list_checkout_items}', description: '' },
      { Id: '', Category: 'Order', Name: 'Pick List Key - Definition', insertValue: '${pick_list_key}', description: '' },
  
      ];

//define the country DropDownList data
public countryData: { [key: string]: Object }[] = [
  { CountryName: 'Australia', CountryId: '2' },
  { CountryName: 'United States', CountryId: '1' }
];
//define the state DropDownList data
public placeHolderdata: { [key: string]: Object }[] = [
  { StateName: 'US state -1', CountryId: '1', SateId: '101' },
  { StateName: 'US state -2 ', CountryId: '1', SateId: '102' },
  { StateName: 'Australia State -1 ', CountryId: '2', SateId: '105' },
  { StateName: 'Australia State -2', CountryId: '2', SateId: '106' },
  { StateName: 'US state -3 ', CountryId: '1', SateId: '108' },
  { StateName: 'Australia State -3 ', CountryId: '2', SateId: '109' },
  { StateName: 'url', SateId: 'url',CountryId: '0'},
{ StateName: 'userid', SateId: 'userid',CountryId: '0'},
{ StateName: 'username.loginemail', SateId: 'username.loginemail',CountryId: '0'},
{ StateName: 'emailotp', SateId: 'emailotp', EntityId:0 ,CountryId: '0' },
{ StateName: 'emailotpvalidaity', SateId: 'emailotpvalidaity',CountryId: '0' },
{ StateName: 'password', SateId: 'password',CountryId: '0' }
];

public countryFields: Object = { text: 'CountryName', value: 'CountryId' };
// public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
client_fields: Object = { text: 'user_full_name', value: 'user_id' };
public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
public data_sector_fields: Object = { text: 'log_type_data_sector_name', value: 'log_type_data_sector_id', icon: 'log_type_data_sector_icon', colour: 'log_type_data_sector_colour', is_active: 'is_active', description: 'log_type_data_sector_description'}; // using the name field not id!


  constructor(
    private _mysqlService: MysqlService,
    private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private _demoService: DemoService,
      vcr: ViewContainerRef,
      private modalService: BsModalService,
      private _location: Location,
      public gfunc: GlobalFunctionsService,
      public toastr: HotToastService,
      private sanitizer: DomSanitizer,
      public datepipe: DatePipe,
      public legalDate: LegalDateTimeService,
  ) {
    this.nav = document.querySelector('nav.navbar');
    // this.toastr.setRootViewContainerRef(vcr);

       // need to add this as routes does not work globally
       this.all_router_details = this.router.url;
       this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

    this.system_automation_id = +this.route.snapshot.paramMap.get('system_automation_id');


// Dynamic Variables
this.search_model = {
  is_active: 1,
  // job_type_id: res.job_type_id,
  // variable_code_block_type_id: res.variable_code_block_type_id,
  // job_type_location_id: res.job_type_location_id,
  // job_type_court_id: res.job_type_court_id,
  // variable_code_block_insert_type_id: res.variable_code_block_insert_type_id,
  // "variable_code_block_insert_type_id": 2, //pdfs only

 };
 this.getVariableCodeBlocksSearchFull(this.search_model)


   }

  ngOnInit() {
    // this.baseUploadURL = this.gfunc.baseUploadURL_BrandAssets + '/'  + this.doc_id; // no trailing slash
    this.baseUploadURL = this.gfunc.baseUploadURL; // all templates reside in the same directory.
    this.baseUploadURLOriginalWordTemplates = this.gfunc.baseUploadURLOriginalWordTemplates;
    this.baseUploadURLEmailTemplates = this.gfunc.baseUploadURLEmailTemplates; // all templates reside in the same directory.
    this.baseUploadURLDocxThemeTemplates = this.gfunc.baseUploadURLDocxThemeTemplates;
   // this.model = new SubjectTemplateDocs(); only for create components
 
 this.brand_id = this.gfunc.sessionBrandId;

   this.model = new SystemAutomation();
   this.legalDatePickerValues = {};


   this.model.updated_date = this.gfunc.todayDate;
   this.model.updated_by = this.gfunc.sessionUserId;

   

   this.getSystemAutomation(this.system_automation_id);
    this.getBrandTypes();
    this.getNoteTypes();
    this.getSubjectComTypes();
    this.getJobTypes();
    this.getBrandById(this.gfunc.sessionBrandId);
    this.getSystemLogTypeDataSectors();

    this.getUsers();

    // for date changes and status updates
    this.getJobStatusNames();

    this.opened(); // refresh the UI for rich text editor

// GET THE TRIGGERED LOGS TYPES THAT ARE USING THIS AUTOMATION
        // Send the single ID as an array.
  let new_model = {
    system_automation_array: '["' + this.system_automation_id + '"]'
  }
  this.getSystemAutomationLogTypeTriggersByArray(new_model);


  }

  getLegalDatePickerValue(model: any, field: string): Date | null {
    return this.legalDatePickerValues[field] ?? this.legalDate.toPickerDate(model?.[field]);
  }

  onLegalDateChange(model: any, field: string, value: unknown): void {
    const pickerDate = this.legalDate.coercePickerDate(value);
    this.legalDatePickerValues[field] = pickerDate;
    model[field] = this.legalDate.fromPickerDate(pickerDate);
  }


  getUsers() {
    this._demoService.getUsers().subscribe(
       data => { this.users = data; },
       err => console.error(err),
       () => console.log('done loading users')
     );
   }
  
  


  getSubjectTemplateDoc(doc_id) {
    this._demoService.getSubjectTemplateDoc(doc_id).subscribe(
      data => { this.subject_template_doc = data;
        const res = data[0];
        // load the drop downs
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
        this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
        // this.getJobTypes();

      },
      err => console.error(err),
      () => console.log('')
    );
  }




  private getSystemAutomation(system_automation_id) {
    this._demoService.getSystemAutomation(system_automation_id)
      .subscribe(
        res => {this.system_automation = res;

          let data= res[0];

          // if statements to step from from loading errors 
          if(this.system_automation[0].system_file_array){
          this.allFileAutomations = JSON.parse(this.system_automation[0].system_file_array);
        
          let new_model = {
            system_file_array: JSON.parse(this.system_automation[0].system_file_array)
          }
          this.getSystemSubjectTemplateDocsArray(new_model);
        
        
        }


          if(this.system_automation[0].system_communication_array){
          this.allCommunicationsAutomations = JSON.parse(this.system_automation[0].system_communication_array);

          let new_model_b = {
            system_communication_array: JSON.parse(this.system_automation[0].system_communication_array)
          }
          this.getSystemSubjectTemplateDocsArray_Communications(new_model_b);

          }




          if(this.system_automation[0].system_conditions_array){
          this.allConditionsAutomations = JSON.parse(this.system_automation[0].system_conditions_array);

          let new_model_c = {
            system_conditions_array: JSON.parse(this.system_automation[0].system_conditions_array)
          }
          this.getSystemSubjectTemplateDocsArray_Conditions(new_model_c);


          }






          // Need to ad 2.0 fields to load here... to load the presets.
          if(this.system_automation[0].system_file_array_2){
          this.allFileAutomations_2 = JSON.parse(this.system_automation[0].system_file_array_2);



          // Need to pass All the 2.0 Models here to load the presets
          let new_model_d = {
            system_file_array: JSON.parse(this.system_automation[0].system_file_array_2)
          }
          this.getSystemSubjectTemplateDocsArray_2(new_model_d);





          }
          if(this.system_automation[0].system_communication_array_2){
          this.allCommunicationsAutomations_2 = JSON.parse(this.system_automation[0].system_communication_array_2);


          let new_model_e = {
            system_communication_array: JSON.parse(this.system_automation[0].system_communication_array_2)
          }
          this.getSystemSubjectTemplateDocsArray_Communications_2(new_model_e);

          }






          
  




        },
        err => console.error(err.status)
      );
  }

  

  getSystemAutomationLogTypeTriggersByArray(request_array) {
    this._demoService.getSystemAutomationLogTypeTriggersByArray(request_array).subscribe(
       data => { this.system_log_type_automation_triggers = data;
        let res = data[0];
  
        // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
        // // console.log(this.arrCase);
        // this.Items = data['Items'] ;
        // this.sent_data = this.Items;
        // this.sent_data = this.myob_account_codes;



        // I need to do a loop of the entire array not just a single.
        // Then push the logtypeid and names to an new array. - show display array only.

// An array of objects
      // var persons = [{name: "Harry"}, {name: "Alice"}, {name: "Peter"}];
      // var logs_type_triggers = JSON.parse(data[5].system_automation_array);
      // console.log('AutomationArray: ' + logs_type_triggers)
      // if(logs_type_triggers.some(person => person == this.system_automation_id )){
      //   alert("Object found inside the array.");
      // } else{
      //   alert("Object not found.");
      // }



      // Working function to filter and create an array Log Type Items - Triggers Exists in .. (system_automations_array)
this.array_of_triggers = [];
 // Count items of brand search to loop through
 let  count_of_trigger_items = Object.keys(this.system_log_type_automation_triggers).length;
 // now loop and push to join model

 if(count_of_trigger_items >= 1){

 for(let i=0;i < count_of_trigger_items; i++) {
   let res2 = this.system_log_type_automation_triggers[i];
   var logs_type_triggers = JSON.parse(data[i].system_automation_array);
     // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
     if(logs_type_triggers.some(person => person == this.system_automation_id )){

     this.array_of_triggers.push({
    log_type_name: res2.log_type_name,
    log_type_id: res2.log_type_id,
    log_type_colour: res2.log_type_colour,
    log_type_icon: res2.log_type_icon,
    log_type_description: res2.log_type_description,
    is_active: res2.is_active,
             });

            } // end if exists in the current row array
 
 } // end brands loop.
 }
 this.array_of_triggers = this.array_of_triggers;





// Find if the array contains an object by comparing the property value
// if(persons.some(person => person.name === "Peter")){
//     alert("Object found inside the array.");
// } else{
//     alert("Object not found.");
// }


  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


// need to change this below
editDoc(model) {
  // model.job_id = this.job_id;
   this._demoService.updateSubjectTemplateDoc(model).subscribe(

    data => { // this.trace_candidate_update = data;
      // refresh the list
     // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    this.toastr.success('Communication Template Updated Successfully');
  //  this.createJobSubjectsMultiple(model);
    // Subject to reload the manager component parent.
   // TraceCandidateManagerComponent.returned.next(false);
   // Refreshes itself
   this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
   .then(() => this.router.navigate(['admin/communication/com_type_template_doc_edit/' + model.doc_id]));

              return true;
    },
    // error => {
    //  // console.error('Error saving Event!');
    //   this.toastr.error('Error saving Document!');
    //   return Observable.throw(error);
    // },
    err => {
      this.toastr.error('Error Saving Updates to the Communication Template!');
      console.error(err)
    },
    () => console.log('done updates')
);
  }




// need to change this below
updateSystemAutomation(model) {

  model.updated_date = this.gfunc.todayDate;
  model.updated_by = this.gfunc.sessionUserId;
  // model.job_id = this.job_id;
           this._demoService.updateSystemAutomation(model).subscribe(

            data => { // this.trace_candidate_update = data;
              // refresh the list
             // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
            this.toastr.success('System Automation Successfully');
          //  this.createJobSubjectsMultiple(model);
            // Subject to reload the manager component parent.
           // TraceCandidateManagerComponent.returned.next(false);
           // Refreshes itself
        // this.gfunc.globalSystemAutomationUpdateSkipRoute(this.system_automation_id);
        this.changes_made = '';

                      return true;
            },
            // error => {
            //  // console.error('Error saving Event!');
            //   this.toastr.error('Error saving Document!');
            //   return Observable.throw(error);
            // },
            err => {
              this.toastr.error('Error Saving Automation!');
              console.error(err)
            },
            () => console.log('done updates')
        );
  }







 getBrandTypes() {
  this._demoService.getBrandBrandTypes().subscribe(
     data => { this.brand_types = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }
 getNoteTypes() {
  this._demoService.getNoteTypes().subscribe(
     data => { this.note_types = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }



// Edit a Theme component.
editThemeFile(file_id, filename){
  this.router.navigate(['/admin/system-file-manager/system-doc-edit/theme-docx-edit/' + file_id + '/' + filename]);
};

     // to router navigate back
     public goBack() {
      this._location.back();
    }

    docView(doc_id) {
      this.router.navigate(['/admin/communication/com_type_template_doc_view/' + doc_id + '']);
    }

    docEdit(doc_id) {
      this.router.navigate(['/admin/communication/com_type_template_doc_edit/' + doc_id + '']);
    }





   // MODAL view a component
   openModalWithComponent() {
    const initialState = {
      title: 'Upload Template Document',
      item_id: 1010,
      doc_id: this.doc_id,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UploadDocxTemplateModalComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.doc_id = this.doc_id;
    this.bsModalRef.content.item_id = this.doc_id;
    this.bsModalRef.content.title = 'Communication Template Document Manager';
    this.bsModalRef.content.closeBtnName = 'Close';
   // this.bsModalRef.content.brand_model = this.subject_template_doc;
    // subscribed to the emitter and get the value.
                //     this.bsModalRef.content.action.take(1).subscribe((value) => {
                //   // console.log(value); // here you will get the value of the file
                //   // Remove the "uploads/" part from the filename.
                //   this.filenameselected = value;
                // // this.stripped = this.filenameselected.replace('uploads/', '');
                //   // this.model.main_image = this.stripped; // works for simple add not update.
                //   // console.log(this.stripped);
                //   // console.log(this.model);
                //   // this.form.logo = this.stripped;
                //   this.form.doc_template_file = this.filenameselected;
                //   // this.form.reset();
                //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                //   this.form.controls['doc_template_file'].patchValue(this.form.doc_template_file);

                //   });
                this.bsModalRef.content.hide.action.subscribe(this.modalRef.hide());    
                  this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// Angular 14 working.....

   }


		// :: Parent / Child modal test
		public addFileNameFromModal(filename) {
		  alert('Clicked');
		  this.form.controls['doc_template_file'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};




      // MODAL view a component
      openModalDotComponent() {
        const initialState = {
          title: 'Upload Template Document',
          item_id: 1010,
          doc_id: this.doc_id,
          size: 'lg',
          backdrop: true,
          IgnoreBackdropClick: false,
        };
        this.bsModalRef = this.modalService.show(UploadDotTemplateModalComponent, {initialState});
        // sets the var to in the component model
        this.bsModalRef.content.doc_id = this.doc_id;
        this.bsModalRef.content.item_id = this.doc_id;
        this.bsModalRef.content.title = 'Original Word Files';
        this.bsModalRef.content.closeBtnName = 'Close';
       // this.bsModalRef.content.brand_model = this.subject_template_doc;
        // subscribed to the emitter and get the value.
              //     this.bsModalRef.content.action.take(1).subscribe((value: any) => {
              //   // console.log(value); // here you will get the value of the file
              //   // Remove the "uploads/" part from the filename.
              //   this.filenameselected = value;
              //  // this.stripped = this.filenameselected.replace('uploads/', '');
              //   // this.model.main_image = this.stripped; // works for simple add not update.
              //   // console.log(this.stripped);
              //   // console.log(this.model);
              //   // this.form.logo = this.stripped;
              //  // this.form.doc_template_file = this.filenameselected;
              //   this.form.original_doc_file = this.filenameselected;
              //   // this.form.reset();
              //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
              //   this.form.controls['original_doc_file'].patchValue(this.form.original_doc_file);

              //   });

              this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_ODF.bind(this)); /// Angular 14 working.....

       }


		// :: Parent / Child modal test
		public addFileNameFromModal_ODF(filename) {
		  alert('Clicked');
		  this.form.controls['original_doc_file'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};

       

   // MODAL view a component
   openModalEmailTemplates() {
    const initialState = {
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UploadEmailTemplateModalComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.doc_id = this.doc_id;
    this.bsModalRef.content.item_id = this.doc_id;
    this.bsModalRef.content.title = 'Email Template Manager';
    this.bsModalRef.content.closeBtnName = 'Close';
   // this.bsModalRef.content.brand_model = this.subject_template_doc;
    // subscribed to the emitter and get the value.
        //     this.bsModalRef.content.action.take(1).subscribe((value) => {
        //   // console.log(value); // here you will get the value of the file
        //   // Remove the "uploads/" part from the filename.
        //   this.filenameselected = value;
        //  // this.stripped = this.filenameselected.replace('uploads/', '');
        //   // this.model.main_image = this.stripped; // works for simple add not update.
        //   // console.log(this.stripped);
        //   // console.log(this.model);
        //   // this.form.logo = this.stripped;
        //   this.form.email_template = this.filenameselected;
        //   // this.form.reset();
        //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
        //   this.form.controls['email_template'].patchValue(this.form.email_template);

        //   });
        this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_ET.bind(this)); /// Angular 14 working.....
   }



		// :: Parent / Child modal test
		public addFileNameFromModal_ET(filename) {
		  alert('Clicked');
		  this.form.controls['email_template'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};






   private getSubjectComTypes() {
    this._demoService.getSubjectComTypes()
      .subscribe(
        res => this.subject_com_types = res,
        err => console.error(err.status)
      );
  }



sendSubjectComTypeID(subject_com_type_id) {
// do nothing
  }



   // BOF SHARMANS CALLS
   getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobSubjectTypes() {
    this._demoService.getJobSubjectTypes().subscribe(
       data => { this.job_subject_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobPlaintiffTypes() {
    this._demoService.getJobPlaintiffTypes().subscribe(
       data => { this.job_plaintiff_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....



   console.log('sending Count:' + this.count2);
  }


  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
       data => { this.job_type_courts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....



   console.log('sending Location:' + this.sent_job_type_location_id);
  }


  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
       data => { this.job_type_document_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....


   console.log('sending Court Type:' + this.sent_job_type_court_id);
  }


  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
       data => { this.job_type_affidavit_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   sendJobTypeAffidavitTypesID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_document_type_id = job_type_document_type_id;
    this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....

   console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }


 // get name for form.
 getJobTypeAllAffidavitType(job_type_affidavit_type_id) {
  this._demoService.getJobTypeAllAffidavitType(job_type_affidavit_type_id)
    .subscribe(
      res => this.get_name = res,
      err => console.error(err.status)
    );
}
getSubjectTemplateDocsCheck(model) {
  // need to do a lookup to get name of doc....
 // this.getJobTypeAllAffidavitType(model.job_type_affidavit_type_id);
  // set the name
  // this.model.doc_name = this.get_name[0].job_type_affidavit_type_name;
   this._demoService.getSubjectTemplateDocsCheck(model).subscribe(
      data => { this.doc_check = data;
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  docEditTemplateFile(doc_id) {
    this.router.navigate(['/admin/communication/template_doc_view/template/' + doc_id + '']);
  }



      // MODAL view a component
      openModalUploadDocxThemeTemplate() {
        const initialState = {
          title: 'Upload Docx Theme Document',
          item_id: 1010,
          doc_id: this.doc_id,
          size: 'lg',
          backdrop: true,
          IgnoreBackdropClick: false,
        };
        this.bsModalRef = this.modalService.show(UploadDocxThemeTemplateComponent, {initialState});
        // sets the var to in the component model
        this.bsModalRef.content.doc_id = this.doc_id;
        this.bsModalRef.content.item_id = this.doc_id;
        this.bsModalRef.content.title = 'Original Word Theme Files';
        this.bsModalRef.content.closeBtnName = 'Close';
       // this.bsModalRef.content.brand_model = this.subject_template_doc;
        // subscribed to the emitter and get the value.
                //     this.bsModalRef.content.action.take(1).subscribe((value) => {
                //   // console.log(value); // here you will get the value of the file
                //   // Remove the "uploads/" part from the filename.
                //   this.filenameselected = value;
                //  // this.stripped = this.filenameselected.replace('uploads/', '');
                //   // this.model.main_image = this.stripped; // works for simple add not update.
                //   // console.log(this.stripped);
                //   // console.log(this.model);
                //   // this.form.logo = this.stripped;
                //  // this.form.doc_template_file = this.filenameselected;
                //   this.form.document_base_theme_docx = this.filenameselected;
                //   // this.form.reset();
                //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                //   this.form.controls['document_base_theme_docx'].patchValue(this.form.document_base_theme_docx);

                //   });
                this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_TD.bind(this)); /// Angular 14 working.....
       }

		// :: Parent / Child modal test
		public addFileNameFromModal_TD(filename) {
		  alert('Clicked');
		  this.form.controls['document_base_theme_docx'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};



    // Insert text to position on textbox
    insertTextToPoistion(fieldName: string, currentValue: string, args){
      // let newValue = '';
      let start= 0;
      let end = 0;
      let newValue = args.value;
      let textarea:  HTMLTextAreaElement = <HTMLTextAreaElement>document.getElementById(fieldName);
      this.toastr.info('Variable Added at cursor position within document: ' + args.value);

      textarea.value = currentValue + ' ' + args.value;
      // this.model.note_template_owner = currentValue + ' ' + args.value; // make sure the model is upadted to insert more than one.

          // start = textarea.selectionStart;
          // end = textarea.selectionEnd;
          // newValue = currentValue.substring(0,start) + newValue + currentValue.substring(end);
          // // textarea.selectionStart = textarea.selectionEnd - start + newAddText.lenght
          // return newValue;
    }

    // Insert text to position on textbox
    insertTextToPoistion_input(fieldName: string, currentValue: string, args){
      // let newValue = '';
      let start= 0;
      let end = 0;
      let newValue = args.value;
      // let textarea:  HTMLTextAreaElement = <HTMLTextAreaElement>document.getElementById(fieldName);
      let textarea: HTMLInputElement = <HTMLInputElement>document.getElementById(fieldName);
      this.toastr.info('Variable Added at cursor position within document: ' + args.value);

      textarea.value = currentValue + ' ' + args.value;
      // this.model.note_template_owner = currentValue + ' ' + args.value; // make sure the model is upadted to insert more than one.

          // start = textarea.selectionStart;
          // end = textarea.selectionEnd;
          // newValue = currentValue.substring(0,start) + newValue + currentValue.substring(end);
          // // textarea.selectionStart = textarea.selectionEnd - start + newAddText.lenght
          // return newValue;
    }





    

    // This allows erfresh of the drop down data dynamically
    public onFiltering(args): void { 
      this.listObj.dataSource = this.job_dropdown_data; 
  } 


  public onFiltering_dynamic(args): void { 
    this.dropdownVariablesDynamic.dataSource = this.dynamic_data
} 


    // // :: Job Drop Down Details
public job_fields: Object = { text: 'Name', value: 'insertValue' };
public job_fields_categories: Object = { groupBy: 'Category', text: 'Name', value: 'insertValue' };
public job_text: string = 'Job Details';
public job_dropdown_data: { [key: string]: Object }[] =
[

  { Id: '', Category: 'Job', Name: 'Job Status', insertValue: '${job_status_code}', description: '' },
  { Id: '', Category: 'Job', Name: 'Job Number', insertValue: '${job_number}', description: '' },
  { Id: '', Category: 'Job', Name: 'Job Type', insertValue: '${job_type_name}', description: '' }, // replaced by name or business name
  { Id: '', Category: 'Job', Name: 'Job Type Location', insertValue: '${job_type_location_name}', description: '' },
  { Id: '', Category: 'Job', Name: 'Job Type Court', insertValue: '${job_type_court_name}', description: '' },
  { Id: '', Category: 'Job', Name: 'Job Type Document Type', insertValue: '${job_type_document_type_name}', description: '' },
  { Id: '', Category: 'Job', Name: 'Job Type Affidavit Type', insertValue: '${job_type_affidavit_type_name}', description: '' },
  { Id: '', Category: 'Job', Name: 'Job Subject Type', insertValue: '${job_subject_type_name}', description: '' },
  { Id: '', Category: 'Job', Name: 'Job Plaintiff Type', insertValue: '${job_plaintiff_type_name}', description: '' },
  { Id: '', Category: 'Job', Name: 'Job Report Client Name', insertValue: '${job_client_report_name}', description: '' },
];



// // drop down function
onChangeVariables(args): void {
  //  let element: HTMLElement = document.createElement('p');
  if (args.isInteracted) {
    //  element.innerText = 'Changes happened by Interaction';
    // this.container.documentEditor.editor.insertText(args.value);
    this.toastr.info('Variable Added at cursor position within document: ' + args.value);
    // hide the modal
    this.modalRef.hide();
    this.onChangePromtSave('');
  } else {
    // element.innerText = 'Changes happened by programmatic';
  }

  // document.getElementById('event').append(element);
};



// // drop down function
// onChangeVariables(args): void {
//   //  let element: HTMLElement = document.createElement('p');
//   if (args.isInteracted) {
//     //  element.innerText = 'Changes happened by Interaction';
//     this.container.documentEditor.editor.insertText(args.value);
//     // this.toastr.info('Variable Added at cursor position within document');
//     // hide the modal
//     this.modalRef.hide();
//   } else {
//     // element.innerText = 'Changes happened by programmatic';
//   }

//   // document.getElementById('event').append(element);
// };





public onChangeSetThisModel(model){
  // this.model = model;
  // console.log('promoID:' + model.promotion_id);
  this.promotion_id = this.form.controls['pps_promotion_id'].value;
    console.log('promoID:' + this.promotion_id);
  // this.form.controls['woo_coupon_id'].patchValue(data.id);
}


    public onClickPromotionButton() {
      // this.rteObj.focusIn();
      this.openModalWithComponent_Promotion();
  }
  

     // MODAL view a component
     openModalWithComponent_Promotion() {
      const initialState = {
        title: 'Select Promotion Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: this.subject_template_doc,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }


    getBrandById(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        data => { this.brand = data; },
        err => console.error(err),
        () => console.log('done loading company')
      );
    }


   // this willl have to be avariable.
        // :: Parent / Child modal test
        public insertPromotionFromModal(fileurl) {
          // alert('Clicked Insert');
    
    
                  // Try wrapping an image tag around the image before inserting.
                  // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                  // auto inserts the variable name of theat which was sent.
                  let insert_tag = 'NOT USED -- {{' + fileurl + '}}'
    
          // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
          this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
          // InsertHtml.Insert(document, document.createTextNode(fileurl));
          InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
          // InsertHtml.Insert(document, document.createElement('image') )
    
    
          // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
    
    
          // insertImage(fileurl);
    
          // has to be correct form name
        // this.modalRef.hide();
        // console.log('Added External Recipeint.');
        // this.toastr.info('External Recipient Added');
        };
  
  
        public insertStrFromModal(fileurl) {
          // alert('Clicked Insert');
    
    
                  // Try wrapping an image tag around the image before inserting.
                  // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                  // auto inserts the variable name of theat which was sent.
                  let insert_tag = '' + fileurl + ''
    
          // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
          this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
          // InsertHtml.Insert(document, document.createTextNode(fileurl));
          InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
          // InsertHtml.Insert(document, document.createElement('image') )
    
    
          // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
    
    
          // insertImage(fileurl);
    
          // has to be correct form name
        // this.modalRef.hide();
        // console.log('Added External Recipeint.');
        // this.toastr.info('External Recipient Added');
        };
  
  
        public insertVariableFromModal(fileurl) {
          // alert('Clicked Insert');
    
    
                  // Try wrapping an image tag around the image before inserting.
                  // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                  // auto inserts the variable name of theat which was sent.
                  let insert_tag = '${' + fileurl + '}'
    
          // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
          this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
          // InsertHtml.Insert(document, document.createTextNode(fileurl));
          InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
          // InsertHtml.Insert(document, document.createElement('image') )
    
    
          // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
    
    
          // insertImage(fileurl);
    
          // has to be correct form name
        // this.modalRef.hide();
        // console.log('Added External Recipeint.');
        // this.toastr.info('External Recipient Added');
        };




        public insertImageQRFromModal(fileurl) {
          // alert('Clicked Insert');
    
    
                  // Try wrapping an image tag around the image before inserting.
                  // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
    
                  // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="https://ppsdistrohub.nickbowen.com.au/APP_PHP/uploads/' + fileurl + '" >'

                                  // april 28 2023 - now in assets of brand.
                let link = this.gfunc.baseUploadURL_BrandAssets + '/' + this.brand_id + '/qrcodes/' + fileurl;
                let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="'+ link + '" >'
  
                  // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src=" https://ppsdistrohub.nickbowen.com.au/APP_PHP/uploads/' + fileurl + '" >'
    
          // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
          this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
          // InsertHtml.Insert(document, document.createTextNode(fileurl));
          InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
          // InsertHtml.Insert(document, document.createElement('image') )
    
    
          // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
    
    
          // insertImage(fileurl);
    
          // has to be correct form name
        // this.modalRef.hide();
        // console.log('Added External Recipeint.');
        // this.toastr.info('External Recipient Added');
        };
  




    // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }



  // :: Parent / Child modal test
  public insertImageFromModal(fileurl) {
    // alert('Clicked Insert');


            // Try wrapping an image tag around the image before inserting.
            // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

            let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="' + fileurl + '" >'

    // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
    this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
    // InsertHtml.Insert(document, document.createTextNode(fileurl));
    InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
    // InsertHtml.Insert(document, document.createElement('image') )


    // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 


    // insertImage(fileurl);

    // has to be correct form name
  // this.modalRef.hide();
  // console.log('Added External Recipeint.');
  // this.toastr.info('External Recipient Added');
  };


  public onCreate(): void { 
    let data: { [key: string]: Object }[] = [
        { Id: '2', Name: 'FirstName' },
        { Id: '2', Name: 'LastName' },
        { Id: '3', Name: 'MiddleName' }
    ];
    let proxy = this.rteObj;
     let dropdownVariables: DropDownList = new DropDownList({
        dataSource: data,
        fields: { text: 'Name' },
        placeholder: 'Insert Fields',
        width: '100px',
        change: (args: any)=>{
          proxy.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
    });
    dropdownVariables.appendTo('#dropdownVariables');
    
    
    } 

    public onCreate2(): void { 
      this.proxy = this.defaultRTE;
      // initialize Custom DropDownList component
       this.dropdownVariables = new DropDownList({
        dataSource: this.dataVariables,
        fields: { text: 'Name', value: 'insertValue' },
        // fields: { text: 'Name' },
        placeholder: 'My Details',
        width: '300px',
        change: (args: any)=>{
          this.defaultRTE.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
      });
      this.dropdownVariables.appendTo('#dropdownVariables');


      this.dropdownVariablesDynamic = new DropDownList({
        allowFiltering: true, 
        filtering: (args: any)=>{this.onFiltering_dynamic(args.value)},
        dataSource: this.dynamic_data,
        fields: { text: 'Name', value: 'insertValue' },
        // fields: { text: 'Name' },
        placeholder: 'Dynamic Variables',
        width: '450px',
        change: (args: any)=>{
          this.defaultRTE.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
      });
      this.dropdownVariablesDynamic.appendTo('#dropdownVariablesDynamic');


      this.dropdownVariablesOrder = new DropDownList({
        dataSource: this.dataVariablesOrder,
        fields: { text: 'Name', value: 'insertValue' },
        // fields: { text: 'Name' },
        placeholder: 'Order Variables',
        width: '300px',
        change: (args: any)=>{
          this.defaultRTE.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
      });
      this.dropdownVariablesOrder.appendTo('#dropdownVariablesOrder');

      this.dropdownVariablesOrderSender = new DropDownList({
        dataSource: this.dataVariablesOrderSender,
        fields: { text: 'Name', value: 'insertValue' },
        // fields: { text: 'Name' },
        placeholder: 'Order Sender',
        width: '300px',
        change: (args: any)=>{
          this.defaultRTE.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
      });
      this.dropdownVariablesOrderSender.appendTo('#dropdownVariablesOrderSender');


      this.dropdownVariablesOrderPickList = new DropDownList({
        dataSource: this.dataVariablesOrderPickList,
        fields: { text: 'Name', value: 'insertValue' },
        // fields: { text: 'Name' },
        placeholder: 'Pick List Items',
        width: '300px',
        change: (args: any)=>{
          this.defaultRTE.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
      });
      this.dropdownVariablesOrderPickList.appendTo('#dropdownVariablesOrderPickList');


      this.dropdownVariables_AutomationGeneral = new DropDownList({
        allowFiltering: true, 
        filtering: (args: any)=>{this.onFiltering_automationGeneral(args.value)},
        dataSource: this.automationGeneral_data,
        fields: { text: 'Name', value: 'insertValue' },
        // fields: { text: 'Name' },
        placeholder: 'Automation General',
        width: '450px',
        change: (args: any)=>{
          this.defaultRTE.focusIn();
          InsertHtml.Insert(document, document.createTextNode(args.value));
        }
      });
      this.dropdownVariables_AutomationGeneral.appendTo('#dropdownVariablesAutomationGeneral');

    }



    public onFiltering_automationGeneral(args): void { 
      this.dropdownVariables_AutomationGeneral.dataSource = this.automationGeneral_data
  } 


  // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
}


    oncreated() {
      this.proxy = this;  
      // initialize Custom DropDownList component
       this.dropDownListObject = new DropDownList({
          placeholder: "Select PlaceHolder Value",
          width: "180px",
          fields: { text: 'StateName', value: "SateId" },
          // change: (args: any)=>{
          //   this.defaultRTE.focusIn();
          //   InsertHtml.Insert(document, document.createTextNode(args.value));
          // }
          change: this.OnChanged.bind(this),
          //set the data to dataSource property
          dataSource: this.placeHolderdata
      });
      this.dropDownListObject.appendTo('#ddlelement');
    }
    //Parent dropdown change event
  
        //pass the filter data source, filter query to updateData method.
    public countryChange(): void {
      let predicate = new Predicate('CountryId', 'equal', this.countryObj.value, true);
      predicate = predicate.or('CountryId', 'equal','0' ,true);
      let query: Query = new Query();
        //frame the query based on search string with filter type.
        query = query.where(predicate);
      // let tempQuery: Query = new Query().where('CountryId', 'equal', this.countryObj.value); // commented out in example
      //     this.dropDownListObject.query = tempQuery;
          this.dropDownListObject.query = query;
            this.dropDownListObject.text = null;
              this.dropDownListObject.dataBind();
              this.isParentDropdownChanged = true;
              
    }
    OnChanged(args) { 
      //Change the Rich Text Editor placeholder
      // this.defaultRTE.placeholder = args.value;
      this.defaultRTE.focusIn();
      InsertHtml.Insert(document, document.createTextNode(args.value));


      this.RTEemail_template_owner.focusIn();
      InsertHtml.Insert(document, document.createTextNode(args.value));
  
    }
    clicked() {
      this.defaultDialog.show();
    }


// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: false, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
//  this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};



// Dynamic Variables
getVariableCodeBlocksSearchFull(search_model) {
  // search_model.brand_type_id = 3;
  // search_model.access_level = 5;
  this._demoService.getVariableCodeBlocksSearchFull(search_model).subscribe(
    data => { this.variable_code_blocks_metrix_search_full = data;
     let res = data[0];
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
     
     
      this.variable_code_blocks_metrix_search_full_results = DataUtil.parse.parseJson(data);
      // this.subject_service_metrix_search_full_results = data;
      this.new_data = this.variable_code_blocks_metrix_search_full_results.slice(0, 500);


// Do while push objects to model...
let  count_of_items = this.new_data.length;
var dropdopwn_items = [];
for(let i=0; i < count_of_items; i++) {
  let itemData = this.new_data[i];
// push to array to fill below.
dropdopwn_items.push({ 
  Id: itemData.variable_code_block_id,
  Category: itemData.log_type_data_sector_name,
  Name: itemData.variable_code_block_name,
  insertValue: itemData.variable_code_block_as_variable,
  description: ''
});







}


// AUTOMATERION GENERAL VARIABLE ITEMS

// Set some fileters and create Arrays of drop down lists components for the drop down menu systems
let newArr = Object(data).filter((sbi)=>(sbi.log_type_data_sector_id == 8)); // User this if filter is needed.
// WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
var dropdown_GeneraAutomation = DataUtil.parse.parseJson(newArr);
let  count_GeneraAutomation = dropdown_GeneraAutomation.length;
var dropdopwn_items_GeneraAutomation = [];
for(let i=0; i < count_GeneraAutomation; i++) {
  let itemData2 = dropdown_GeneraAutomation[i];

  dropdopwn_items_GeneraAutomation.push({ 
    Id: itemData2.variable_code_block_id,
    Category: itemData2.log_type_data_sector_name,
    Name: itemData2.variable_code_block_name,
    insertValue: itemData2.variable_code_block_as_variable,
    description: ''
  });

}

// let  count_of_items = Object.keys(this.new_data).length;
//   // need to do a loop of subject_cost items (.length)
//   for(let i=0; i < count_of_items; i++) {
//     let itemData = this.row_data[i];

//     if(itemData[i].myob_tax_code_id == '1') {
//       this.row_data[i].tax = (itemData[i].cost_task_fee / (100 / 10)) * itemData[i].qty;
//     }
//     if(itemData[i].myob_tax_code_id == '2') {
//       this.row_data[i].tax = 0;
//     }
//   } // end for loop of count array



        // // Count items of brand search to loop through
        // let  count_of_brand_items = Object.keys(this.brand_search).length;
        // // now loop and push to join model
        // for(let i=0;i < count_of_brand_items; i++) {
        //   let res = this.brand_search[i];

        //     // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
        //     this.brand_user_join_results.push({
        //       email_address: res.email,
        //       first_name: res.name,
        //       surname: res.surname,
        //       company_name: res.name,
        //       created: res.created,
        //             });

        // } // end brands loop.







        // Setup DropDownMenu Data 
      let  dynamic_dropdown_data: { [key: string]: Object }[] =
[
...dropdopwn_items,
  // { Id: '', Category: 'Job', Name: 'Job Status', insertValue: '${job_status_code}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Number', insertValue: '${job_number}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Type', insertValue: '${job_type_name}', description: '' }, // replaced by name or business name
  // { Id: '', Category: 'Job', Name: 'Job Type Location', insertValue: '${job_type_location_name}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Type Court', insertValue: '${job_type_court_name}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Type Document Type', insertValue: '${job_type_document_type_name}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Type Affidavit Type', insertValue: '${job_type_affidavit_type_name}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Subject Type', insertValue: '${job_subject_type_name}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Plaintiff Type', insertValue: '${job_plaintiff_type_name}', description: '' },
  // { Id: '', Category: 'Job', Name: 'Job Report Client Name', insertValue: '${job_client_report_name}', description: '' },
];

let  automationGeneral_dropdown_data: { [key: string]: Object }[] = [...dropdopwn_items_GeneraAutomation,
  // { Id: '', Category: 'Job', Name: 'Job Status', insertValue: '${job_status_code}', description: '' },
];

    
this.dynamic_data = dynamic_dropdown_data;
this.automationGeneral_data = automationGeneral_dropdown_data;
    //  this.grid.refresh();
 
    

      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      // return Observable.throw(error);
      }
      );
       

}



addRecipientFromModal(model, system_automation_id) {
      //   // alert('parent component function.');
      //  // this.modalService.hide(1); - removed the scroll bard do not use!!!
      //   // this.modalRef.hide();
      //  // this.getJobPlaintiffs(this.job_id);
      //  // this.refreshGrid(); // resets the grid if updated and closed.
      // //  this.updateTypeClick = false; // closes the div
      // // :: reset the entire page.
      // // this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

      // // this.allRecipients.push({
      // //   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
      // //   recipient_email_address: model.recipient_email_address,
      // //   recipient_brand_id: null,
      // //   recipient_brand_type_id: null,
      // //   recipient_user_id: null,
      // //   recipient_user_level_id: null,
      // //   recipient_type_name: model.recipient_type_name,
      // //   model.system_automation_id,
      // // });

      // this.allRecipients.push(
      //   system_automation_id
      // );

      // this.allRecipients = this.allRecipients;
      // // this.model.allRecipients = this.allRecipients;

      // // this.model.system_automation_array = this.allRecipients;

      // // model.allRecipients = this.allRecipients;

      // // this.model.system_automation_array.push(
      // //   system_automation_id
      // // )


      // this.modalRef.hide();
      // // console.log('Added External Recipeint.');
      // // this.toastr.info('External Recipient Added');
};

addAutomationCommunicationsFromModal(model, system_automation_id) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
//   model.system_automation_id,
// });

this.allCommunicationsAutomations.push(
  system_automation_id
);

this.allCommunicationsAutomations = this.allCommunicationsAutomations;
// this.model.system_automation_array = this.allAutomtaions;

// simple small updated - quick and then refresh the page
// this.model.system_automation_array = JSON.stringify(this.allAutomtaions);
// this.model.log_type_id = this.log_type_id;

this.form.controls['system_communication_array'].patchValue(JSON.stringify(this.allCommunicationsAutomations)); // works by setting the new frorm value from parent modal.
// rest the list
let new_model = {
  system_communication_array: this.allCommunicationsAutomations
}

this.getSystemSubjectTemplateDocsArray_Communications(new_model);


// model.allRecipients = this.allRecipients;

// this.model.system_automation_array.push(
//   system_automation_id
// )
// this.model.system_automation_array = this.allAutomtaions;
// this.updateSystemLogType(model);
// this.getSystemLogType(this.log_type_id);

this.modalRef.hide();
this.onChangePromtSave('');
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};


addAutomationCommunicationsFromModal_2(model, system_automation_id) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
//   model.system_automation_id,
// });

this.allCommunicationsAutomations_2.push(
  system_automation_id
);

this.allCommunicationsAutomations_2 = this.allCommunicationsAutomations_2;
// this.model.system_automation_array = this.allAutomtaions;

// simple small updated - quick and then refresh the page
// this.model.system_automation_array = JSON.stringify(this.allAutomtaions);
// this.model.log_type_id = this.log_type_id;

this.form.controls['system_communication_array_2'].patchValue(JSON.stringify(this.allCommunicationsAutomations_2)); // works by setting the new frorm value from parent modal.
// rest the list
let new_model = {
  system_communication_array: this.allCommunicationsAutomations_2
}

this.getSystemSubjectTemplateDocsArray_Communications_2(new_model);


// model.allRecipients = this.allRecipients;

// this.model.system_automation_array.push(
//   system_automation_id
// )
// this.model.system_automation_array = this.allAutomtaions;
// this.updateSystemLogType(model);
// this.getSystemLogType(this.log_type_id);

this.modalRef.hide();
this.onChangePromtSave('');
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};


addAutomationFromModal(model, system_automation_id) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
//   model.system_automation_id,
// });

this.allFileAutomations.push(
  system_automation_id
);

this.allFileAutomations = this.allFileAutomations;
// this.model.system_automation_array = this.allAutomtaions;

// simple small updated - quick and then refresh the page
// this.model.system_automation_array = JSON.stringify(this.allAutomtaions);
// this.model.log_type_id = this.log_type_id;

this.form.controls['system_file_array'].patchValue(JSON.stringify(this.allFileAutomations)); // works by setting the new frorm value from parent modal.
// rest the list
let new_model = {
  system_file_array: this.allFileAutomations
}

this.getSystemSubjectTemplateDocsArray(new_model);


// model.allRecipients = this.allRecipients;

// this.model.system_automation_array.push(
//   system_automation_id
// )
// this.model.system_automation_array = this.allAutomtaions;
// this.updateSystemLogType(model);
// this.getSystemLogType(this.log_type_id);

this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};



addAutomationFromModal_2(model, system_automation_id) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
//   model.system_automation_id,
// });

this.allFileAutomations_2.push(
  system_automation_id
);

this.allFileAutomations_2 = this.allFileAutomations_2;
// this.model.system_automation_array = this.allAutomtaions;

// simple small updated - quick and then refresh the page
// this.model.system_automation_array = JSON.stringify(this.allAutomtaions);
// this.model.log_type_id = this.log_type_id;

this.form.controls['system_file_array_2'].patchValue(JSON.stringify(this.allFileAutomations_2)); // works by setting the new frorm value from parent modal.
// rest the list
let new_model = {
  system_file_array: this.allFileAutomations_2
}

this.getSystemSubjectTemplateDocsArray_2(new_model);
// this.getSystemSubjectTemplateDocsArray(new_model);


// model.allRecipients = this.allRecipients;

// this.model.system_automation_array.push(
//   system_automation_id
// )
// this.model.system_automation_array = this.allAutomtaions;
// this.updateSystemLogType(model);
// this.getSystemLogType(this.log_type_id);

this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};



// :: Parent / Child modal test
closeParentModelDefault(model) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
};


addConditionFromModal(model, log_type_data_sector_condition_id) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
//   model.system_automation_id,
// });

this.allConditionsAutomations.push(
  log_type_data_sector_condition_id
);

this.allConditionsAutomations = this.allConditionsAutomations;
// this.model.system_automation_array = this.allAutomtaions;

// simple small updated - quick and then refresh the page
// this.model.system_automation_array = JSON.stringify(this.allAutomtaions);
// this.model.log_type_id = this.log_type_id;

this.form.controls['system_conditions_array'].patchValue(JSON.stringify(this.allConditionsAutomations)); // works by setting the new frorm value from parent modal.
// rest the list
let new_model = {
  system_conditions_array: this.allConditionsAutomations
}

this.getSystemSubjectTemplateDocsArray_Conditions(new_model);


// model.allRecipients = this.allRecipients;

// this.model.system_automation_array.push(
//   system_automation_id
// )
// this.model.system_automation_array = this.allAutomtaions;
// this.updateSystemLogType(model);
// this.getSystemLogType(this.log_type_id);

this.modalRef.hide();
this.onChangePromtSave('');
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};








RemoveElementFromAllRecipients(key: number) {
        // // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
        // this.allRecipients.forEach((value, index) => {
        //   if (value === key) {
        //     this.allRecipients.splice(index, 1);
        //   }
        // });

        //   // :: Specifcally removes the array item without there being
        //   // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};


RemoveElementFromAllAutomations(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allFileAutomations.forEach((value, index) => {
    if (value === key) {
      this.allFileAutomations.splice(index, 1);
    }
  });

      this.form.controls['system_automation_array'].patchValue(JSON.stringify(this.allFileAutomations)); // works by setting the new frorm value from parent modal.
      // rest the list
      let new_model = {
        system_automation_array: this.allFileAutomations
      }
      this.getSystemAutomationsArray(new_model);


    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};




RemoveElementFromAllFileAutomations(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allFileAutomations.forEach((value, index) => {
    if (value === key) {
      this.allFileAutomations.splice(index, 1);
    }
  });

      this.form.controls['system_file_array'].patchValue(JSON.stringify(this.allFileAutomations)); // works by setting the new frorm value from parent modal.
      // rest the list
      let new_model = {
        system_file_array: this.allFileAutomations
      }
      this.getSystemSubjectTemplateDocsArray(new_model);


    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};


RemoveElementFromAllFileAutomations_2(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allFileAutomations_2.forEach((value, index) => {
    if (value === key) {
      this.allFileAutomations_2.splice(index, 1);
    }
  });

      this.form.controls['system_file_array_2'].patchValue(JSON.stringify(this.allFileAutomations_2)); // works by setting the new frorm value from parent modal.
      // rest the list
      let new_model = {
        system_file_array: this.allFileAutomations_2
      }
      this.getSystemSubjectTemplateDocsArray_2(new_model);


    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};


RemoveElementFromAllConditionsAutomations(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allConditionsAutomations.forEach((value, index) => {
    if (value === key) {
      this.allConditionsAutomations.splice(index, 1);
    }
  });

      this.form.controls['system_conditions_array'].patchValue(JSON.stringify(this.allConditionsAutomations)); // works by setting the new frorm value from parent modal.
      // rest the list
      let new_model = {
        system_conditions_array: this.allConditionsAutomations
      }
      this.getSystemSubjectTemplateDocsArray_Conditions(new_model);
      this.onChangePromtSave('')

    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};

RemoveElementFromAllFileAutomations_Communications(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allCommunicationsAutomations.forEach((value, index) => {
    if (value === key) {
      this.allCommunicationsAutomations.splice(index, 1);
    }
  });

      this.form.controls['system_communication_array'].patchValue(JSON.stringify(this.allCommunicationsAutomations)); // works by setting the new frorm value from parent modal.
      // rest the list
      let new_model = {
        system_communication_array: this.allCommunicationsAutomations
      }
      this.getSystemSubjectTemplateDocsArray_Communications(new_model);


    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};


RemoveElementFromAllFileAutomations_Communications_2(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allCommunicationsAutomations_2.forEach((value, index) => {
    if (value === key) {
      this.allCommunicationsAutomations_2.splice(index, 1);
    }
  });

      this.form.controls['system_communication_array_2'].patchValue(JSON.stringify(this.allCommunicationsAutomations_2)); // works by setting the new frorm value from parent modal.
      // rest the list
      let new_model = {
        system_communication_array: this.allCommunicationsAutomations_2
      }
      this.getSystemSubjectTemplateDocsArray_Communications_2(new_model);


    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};


getSystemAutomationsArray(request_array) {
  this._demoService.getSystemAutomationsArray(request_array).subscribe(
     data => { this.system_log_type_automations = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getSystemSubjectTemplateDocsArray(request_array) {
  this._demoService.getSystemSubjectTemplateDocsArray(request_array).subscribe(
     data => { this.system_subject_template_docs_automations = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getSystemSubjectTemplateDocsArray_2(request_array) {
  this._demoService.getSystemSubjectTemplateDocsArray(request_array).subscribe(
     data => { this.system_subject_template_docs_automations_2 = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getSystemSubjectTemplateDocsArray_Communications(request_array) {
  this._demoService.getSystemSubjectTemplateDocsArray_Communications(request_array).subscribe(
     data => { this.system_subject_template_docs_automations_commuications = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getSystemSubjectTemplateDocsArray_Communications_2(request_array) {
  this._demoService.getSystemSubjectTemplateDocsArray_Communications(request_array).subscribe(
     data => { this.system_subject_template_docs_automations_commuications_2 = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getSystemSubjectTemplateDocsArray_Conditions(request_array) {
  this._demoService.getSystemSubjectTemplateDocsArray_Conditions(request_array).subscribe(
     data => { this.system_log_type_data_sector_conditions = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getSystemLogTypeDataSectors() {
  this._demoService.getSystemLogTypeDataSectors().subscribe(
     data => { this.system_log_type_data_sectors = data;
    
    },
     err => console.error(err),
     () => console.log('System Log Type')
   );
 }


 setColour(value2){
  console.log('SetColour: ' + value2)
  this.brandForm.log_type_colour.value = this.brandForm.colourpicker.value
}

clearColour(field, model){
  // this.brandForm.system_automation_colour.value = ''
  // model.system_automation_colour.value = '';
  // return model;
  this.form.controls['system_automation_colour'].patchValue(''); 
}

onChangePromtSave(any) {
  //  alert('you have made changes, please remember to save!');
  //  console.log('form changed');
   this.changes_made = null;
  }

  onChangePromtSaveHide() {
    //  alert('you have made changes, please remember to save!');
    //  console.log('form changed');
     this.changes_made = 1;
    }




    openModalWithComponent_Promotion_sendEmailSubjectTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "send_email_client_subject"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'send_email_client_subject',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
              // For Email Subhect filds -- brand from
  
  
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }    
  

    openModalWithComponent_Promotion_sendEmailSubjectTemplatePrivate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "send_privacy_email_client_subject"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'send_privacy_email_client_subject',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
              // For Email Subhect filds -- brand from
  
  
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }    
    



    openModalWithComponent_Promotion_emailSubjectTemplatePrivate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "emailSubjectTemplatePrivate"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'emailSubjectTemplatePrivate',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
              // For Email Subhect filds -- brand from
  
  
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }    
  
  
    openModalWithComponent_Promotion_sendOwnerEmailSubjectTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "send_email_owner_subject"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'send_email_owner_subject',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
              // For Email Subhect filds -- brand from
  
  
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }    
  


    openModalWithComponent_Promotion_sendOwnerEmailSubjectTemplatePrivate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "send_privacy_email_owner_subject"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'send_privacy_email_owner_subject',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
              // For Email Subhect filds -- brand from
  
  
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }    
     

    openModalWithComponent_Promotion_sendAgentEmailSubjectTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "send_email_agent_subject"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'send_email_agent_subject',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
              // For Email Subhect filds -- brand from
  
  
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }    
  

    openModalWithComponent_Promotion_sendAgentEmailSubjectTemplatePrivate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "send_privacy_email_agent_subject"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'send_privacy_email_agent_subject',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
              // For Email Subhect filds -- brand from
  
  
                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }    
  

    
       // this willl have to be avariable.
            // :: Parent / Child modal test

  
  
  
    // Now workes for multiple editors on a page... few!! 11pm 2/12/23
    public insertVariableFromModal_EditorID(fileurl) {
      // alert('Clicked Insert');
  
      console.log(JSON.stringify(fileurl))
      let editorID = fileurl.editorID
      let insert_variable = fileurl.fileurl
  
      this.toastr.info('Variable Inserted: ' + insert_variable)
  
      // this.toastr.info('editorID: ' + editorID)
  
              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
              // auto inserts the variable name of theat which was sent.
            //  pps
              // let insert_tag = '${' + fileurl + '}'
  
              // sharmans
      // let insert_tag = fileurl;
      // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
      // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
  
  
          // // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
          // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
          // // InsertHtml.Insert(document, document.createTextNode(fileurl));
          // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
          // // InsertHtml.Insert(document, document.createElement('image') )
  
          // // Need an if statment and to get the Editor ID , to have muliple occurannces on one page.
  
        


          if (editorID == 'send_email_client_subject'){  
            // Now adds to the subject
            let currentValue =   this.form.controls['send_email_client_subject'].value;
            let newValue = '';
            if(currentValue == null){
              newValue = insert_variable;
            }else{
              newValue = currentValue + ' ' + insert_variable;
            }
            this.form.controls['send_email_client_subject'].patchValue(newValue);
          }
          

          if (editorID == 'send_privacy_email_client_subject'){  
            // Now adds to the subject
            let currentValue =   this.form.controls['send_privacy_email_client_subject'].value;
            let newValue = '';
            if(currentValue == null){
              newValue = insert_variable;
            }else{
              newValue = currentValue + ' ' + insert_variable;
            }
            this.form.controls['send_privacy_email_client_subject'].patchValue(newValue);
          }


          
          if (editorID == 'send_email_owner_subject'){  
            // Now adds to the subject
            let currentValue =   this.form.controls['send_email_owner_subject'].value;
            let newValue = '';
            if(currentValue == null){
              newValue = insert_variable;
            }else{
              newValue = currentValue + ' ' + insert_variable;
            }
            this.form.controls['send_email_owner_subject'].patchValue(newValue);
          }

          if (editorID == 'send_privacy_email_owner_subject'){  
            // Now adds to the subject
            let currentValue =   this.form.controls['send_privacy_email_owner_subject'].value;
            let newValue = '';
            if(currentValue == null){
              newValue = insert_variable;
            }else{
              newValue = currentValue + ' ' + insert_variable;
            }
            this.form.controls['send_privacy_email_owner_subject'].patchValue(newValue);
          }

          


        if (editorID == 'emailSubjectTemplate'){  
        // Now adds to the subject
        let currentValue =   this.form.controls['email_subject_primary'].value;
        let newValue = '';
        if(currentValue == null){
          newValue = insert_variable;
        }else{
          newValue = currentValue + ' ' + insert_variable;
        }
        this.form.controls['email_subject_primary'].patchValue(newValue);
      }
  
      if (editorID == 'emailSubjectTemplatePrivate'){  
        // Now adds to the subject
        let currentValue =   this.form.controls['email_subject_private'].value;
        let newValue = '';
        if(currentValue == null){
          newValue = insert_variable;
        }else{
          newValue = currentValue + ' ' + insert_variable;
        }
        this.form.controls['email_subject_private'].patchValue(newValue);
      }
  
          
      if (editorID == 'send_email_agent_subject'){  
        // Now adds to the subject
        let currentValue =   this.form.controls['send_email_agent_subject'].value;
        let newValue = '';
        if(currentValue == null){
          newValue = insert_variable;
        }else{
          newValue = currentValue + ' ' + insert_variable;
        }
        this.form.controls['send_email_agent_subject'].patchValue(newValue);
      }

      

      if (editorID == 'send_privacy_email_agent_subject'){  
        // Now adds to the subject
        let currentValue =   this.form.controls['send_privacy_email_agent_subject'].value;
        let newValue = '';
        if(currentValue == null){
          newValue = insert_variable;
        }else{
          newValue = currentValue + ' ' + insert_variable;
        }
        this.form.controls['send_privacy_email_agent_subject'].patchValue(newValue);
      }



    if (editorID == 'emailTemplate'){
      this.emailTemplateEditor.focusIn(); // these two lines work for RichTextEditor
      InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
      } 
      
      if (editorID == 'emailTemplatePrivate'){
        this.emailTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
        InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
        }    
  
          // NoteTemplate Editor.
     if (editorID == 'noteTemplate'){
      this.noteTemplateEditor.focusIn(); // these two lines work for RichTextEditor
      InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
     }
  
          // NoteTemplate Editor.
          if (editorID == 'noteTemplatePrivate'){
            this.noteTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
            InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
           }
        
  
     if (editorID == 'defaultRTE'){
      this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
      InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
     }
      // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
  


            
  
      // insertImage(fileurl);
  
      // has to be correct form name
    // this.modalRef.hide();
    // console.log('Added External Recipeint.');
    // this.toastr.info('External Recipient Added');
    };
  
  // Now works to insert uploaded images directly from the tabs for -- blocked for Email Subject
    public insertImageFromModal_EditorID(fileurl) {
     
      // Need to create the new button in HTML widget to click.
      console.log(JSON.stringify(fileurl))
      let editorID = fileurl.editorID
      let insert_variable = fileurl.fileurl
     
      // alert('Clicked Insert');
  
  
              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
              // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="' + fileurl + '" >'
              let insert_tag = '<img class="e-rte-image e-imginline e-img-focus"  src="' + insert_variable + '" >'
  
  
              if (editorID == 'defaultRTE'){
                            // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
              this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
              // InsertHtml.Insert(document, document.createTextNode(fileurl));
              InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
              // InsertHtml.Insert(document, document.createElement('image') )
               }
            
               if (editorID == 'emailSignatureTemplate'){
                this.emailSignatureTemplate.focusIn(); // these two lines work for RichTextEditor
                InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
               }
  
  
               // Ugraded for communications to accept images
  
                if (editorID == 'emailTemplate'){
                  this.emailTemplateEditor.focusIn(); // these two lines work for RichTextEditor
                  InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
  
                } 
  
                if (editorID == 'emailTemplatePrivate'){
                  this.emailTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
                  InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
  
                }    
  
                // NoteTemplate Editor.
                if (editorID == 'noteTemplate'){
                  this.noteTemplateEditor.focusIn(); // these two lines work for RichTextEditor
                  InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
  
                }
  
                // NoteTemplate Editor.
                if (editorID == 'noteTemplatePrivate'){
                  this.noteTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
                  InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                }
  
  
  
  
  
  
                    // // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
                    // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
                    // // InsertHtml.Insert(document, document.createTextNode(fileurl));
                    // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                    // // InsertHtml.Insert(document, document.createElement('image') )
  
  
  
      
  
      // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
  
  
      // insertImage(fileurl);
  
      // has to be correct form name
    // this.modalRef.hide();
    // console.log('Added External Recipeint.');
    // this.toastr.info('External Recipient Added');
    };
  
  
  
      // END OF IMAGE modal 
  



      private getJobStatusNames() {
        this._demoService.getJobStatusNames().subscribe(
          (res) => (this.job_status_run = res),
          (err) => console.error(err.status)
        );
      }



}
